<!--
 * @Description: 
 * @Autor: 
 * @Date: 2021-10-14 11:59:14
 * @LastEditors: lzw
 * @LastEditTime: 2021-10-18 16:41:46
 * @FilePath: \燃气B端\src\views\bigscreen\monitor\MapMarkHover.vue
-->
<template functional>
  <div
    class="map-mouseover"
    :style="{
      left: props.mapMouseoverObj.x + 10 + 'px',
      top: props.mapMouseoverObj.y + 10 + 'px',
    }"
  >
    <div>
      <span
        class="titleicon"
        :class="[props.applicationType ? 'green' : 'online']"
      ></span>
      正常：{{ props.mapMouseoverObj.data.normalNum }}台
    </div>
    <div>
      <span class="titleicon alarm"></span>
      报警：{{ props.mapMouseoverObj.data.alarmNum }}台
    </div>
    <div>
      <span class="titleicon malfunc"></span>
      故障：{{ props.mapMouseoverObj.data.breakDownNum }}台
    </div>
    <div v-if="props.applicationType == 1">
      <span class="titleicon yellow"></span>
      到期：{{ props.mapMouseoverObj.data.expire }}台
    </div>
    <div>
      <span class="titleicon offline"></span>
      离线：{{ props.mapMouseoverObj.data.outlineNum }}台
    </div>
  </div>
</template>

<script>
export default {
  props: {
    applicationType: {
      default: "",
    },
    mapMouseoverObj: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {};
  },
};
</script>

<style scoped lang="less">
// 鼠标移入地图上的点
// 鼠标移入地图上的点
.map-mouseover {
  position: absolute;
  // height: 130px;
  background-color: rgba(22, 54, 122, 0.9);
  // border: 1px #ffffff solid;
  color: #fff;
  font-size: 0.6vw;
  border-radius: 0.2vw;
  top: 0;
  left: 0;
  padding: 0.5vw;
  div {
    margin: 0.3vw 0;
  }
}
.titleicon {
  display: inline-block;
  width: 0.6vw;
  height: 0.6vw;
  border-radius: 50%;
  margin-right: 0.5vw;
}
.online {
  background-color: blue;
}
.malfunc {
  background-color: orange;
}
.yellow {
  background-color: rgb(228, 228, 10);
}
.green {
  background-color: green;
}
.alarm {
  background-color: red;
}
.offline {
  background-color: rgb(161, 159, 159);
}
</style>



// WEBPACK FOOTER //
// src/views/bigscreen/monitor/MapMarkHover.vue